import React from "react";
import { connect } from "react-redux";

import language from "../../../language";
import { Input, Select, Checkbox } from "../../Input";
import Separator from "../../Separator/Separator";

/**
 * The parts of FRM_IMH_SOP_28 that only an emergency release asks for.
 *
 * Controlled by the parent so the whole request still posts in one go: this
 * holds no state of its own.
 *
 * The component list is a tick-list, not a dropdown - releasing uncrossmatched
 * Rh positive cells to an Rh negative recipient is two ticks on the paper, and
 * forcing a single choice would lose half of what was actually authorised. The
 * order is the order printed on the form, because that is what the person
 * filling this in is reading from.
 */
const BIOLOGICAL = [
  { field: "hct", labelKey: "haematocrit" },
  { field: "hb", labelKey: "haemoglobin" },
  { field: "rbcCount", labelKey: "rbc_count" },
  { field: "pltCount", labelKey: "platelet_count" },
  { field: "bleedingTime", labelKey: "bleeding_time" },
  { field: "others", labelKey: "others" },
];

const EmergencyFields = ({
  defaultLanguage,
  options,
  components,
  componentsOther,
  reasons,
  reasonOther,
  biological,
  error,
  onToggleComponent,
  onChange,
  onChangeBiological,
}) => {
  const reasonOptions = (options?.reasons || []).map((el) => ({
    label: el.label,
    value: el.value,
  }));

  return (
    <>
      <Separator
        title={language[defaultLanguage].emergency_release}
        titleClassName="text-primary"
      />

      <div className="col-md-12">
        <label className="form-label">
          {language[defaultLanguage].emergency_requesting_release_of}{" "}
          <span className="error-text">*</span>
        </label>
        {(options?.components || []).map((el) => (
          <Checkbox
            key={el.value}
            label={el.label}
            checked={components.includes(el.value)}
            onCheck={() => onToggleComponent(el.value)}
          />
        ))}
        {error?.components && (
          <span className="text-error">{error.components}</span>
        )}
      </div>

      {components.includes("OTHER") && (
        <div className="col-md-12">
          <Input
            label={language[defaultLanguage].please_specify}
            value={componentsOther}
            onChange={(e) => onChange("componentsOther", e.target.value)}
            error={error?.componentsOther}
            required
          />
        </div>
      )}

      <div className="col-md-6">
        {/* More than one at a time: a haemorrhaging patient who arrived
            without a sample is both, and the paper's free-text box let a
            doctor say so. */}
        <Select
          label={language[defaultLanguage].reason}
          options={reasonOptions}
          isMulti
          value={reasonOptions.filter((el) => reasons.includes(el.value))}
          onChange={(e) =>
            onChange("reasons", (e || []).map((el) => el.value))
          }
          error={error?.reasons}
          required
        />
      </div>

      {reasons.includes("OTHER") && (
        <div className="col-md-6">
          <Input
            label={language[defaultLanguage].please_specify}
            value={reasonOther}
            onChange={(e) => onChange("reasonOther", e.target.value)}
            error={error?.reasonOther}
            required
          />
        </div>
      )}

      {reasons.includes("NO_SAMPLE") && (
        <div className="col-md-12">
          <p className="text-muted">
            {language[defaultLanguage].emergency_no_sample_note}
          </p>
        </div>
      )}

      <Separator
        title={language[defaultLanguage].biological_parameters}
        titleClassName="text-primary"
      />
      <div className="col-md-12">
        <p className="text-muted">
          {language[defaultLanguage].biological_parameters_optional}
        </p>
      </div>
      {BIOLOGICAL.map((el) => (
        <div className="col-md-4" key={el.field}>
          <Input
            label={language[defaultLanguage][el.labelKey]}
            value={biological?.[el.field] || ""}
            onChange={(e) => onChangeBiological(el.field, e.target.value)}
          />
        </div>
      ))}
    </>
  );
};

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;

  return { defaultLanguage };
};

export default connect(mapStateToProps)(EmergencyFields);
